<template>
	<div class="aboutcom">
		<div class="comtop">
			<img src="../../static/img/aboutcom.jpg"/>
			<div class="com-titr">
				<span>
					<img src="../../static/img/abouticon.png"/><b>新闻中心</b>
				</span>
				<p>专业的IT解决方案服务商。主要从事于计算机系统集成、软件开发、IT运<br />
维服务等业务，服务于 政府、学校、医疗、生产企业等行业。</p>
			</div>
		</div>
		<div class="com-detail">
			<div class="com-top-top">
				<h4>公司动态</h4>
				<div class="com-line">
					
				</div>
			</div>
			<!--
            	描述：公司简介
            -->
            <div class="" v-for="news in newsdetail" v-show="news.ID == chalid ">
            	<div class="newsdetailtit">
            		<h4>{{news.title}}</h4>
            	</div>
            	<div class="newsdetailcontent" v-html="news.content">
            		{{news.content}}
            	</div>
            </div>
		</div>
	</div>
</template>

<script>
	export default{
		name : 'aboutcom',
		data(){
			return {
				top : [
				{id : 0 , imgsrc : 'static/img/aboutcom.jpg' , title : '关于我们'},
				],
				chalid : 0,
				comimg : [
				{id :　0　, imgsrc : 'static/img/comabout1.jpg'},
				{id :　1　, imgsrc : 'static/img/comabout2.jpg'},
				],
				scrollWatch: true,
				newsdetail : [],
			}
		},
		mounted(){
			this.getID();
			this.getnews();
		},
		methods : {
			getID(){
				this.chalid = this.$route.params.ID
			},
			getnews(){
				var that = this;
     				this.$http.post('http://www.gd-sc.net:9090',{table : 'news'},{emulateJSON: true}).then((response) => {
			        for(var i=0 ; i<response.body.length ; i++){
			        	var data =  response.body[i].createDate;
			        	response.body[i].createDate = data.substr(0,10)
			        }
			        this.newsdetail = response.body;
			      })
     		},
     		todetail(id){
     			this.$router.push('/Newsdetail/'+id);
     		},
		},
	}
</script>

<style>
	.aboutcom{
		position: relative;
		clear: both;
		width: 100%;
		margin: 0 auto;
	}
	.comtop{
		position: relative;
		width: 100%;
		clear: both;
	}
	.comtop img{
		width: 100%;
	}
	.aboutcom .com-titr{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    right: 0vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-titr img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-titr p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-titr b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.com-detail{
		width: 80%;
		margin: 60px auto;
		position: relative;
		clear: both;
		text-align: left;
	}
	.com-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}
	.com-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #1975f0;
		border-radius: 4px;
		top: 8px;
	}
	.com-top-top{
		width: 100%;
		border-bottom: 1px solid #ddd;
		position: relative;
		padding-bottom: 10px;
		margin-bottom: 20px;
	}
	.com-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 0 auto;
		position: relative;
		color: #0066ef ;
		font-weight: 500;
	}
	.newsdetailtit{
		position: relative;
		text-align: center;
		margin: 0 auto;
		padding: 15px 0;
	}
	.newsdetailtit h4{
		color: #333333;
	}
</style>


// WEBPACK FOOTER //
// src/components/newsdetail.vue